import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';


const StoryHighlights = ({ highlights, onHighlightClick }) => {
  const getHighlightIcon = (type) => {
    const icons = {
      'trending': 'TrendingUp',
      'seasonal': 'Calendar',
      'cultural': 'Globe',
      'diy': 'Scissors',
      'luxury': 'Crown',
      'budget': 'DollarSign'
    };
    return icons[type] || 'Gift';
  };

  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-lg text-accent-800">Story Highlights</h3>
        <Button variant="ghost" size="sm" iconName="Plus" className="text-accent-500">
          Add Story
        </Button>
      </div>
      
      <div className="flex space-x-4 overflow-x-auto pb-2">
        {highlights.map((highlight) => (
          <button
            key={highlight.id}
            onClick={() => onHighlightClick(highlight)}
            className="flex-shrink-0 group"
          >
            <div className="relative">
              {highlight.coverImage ? (
                <div className="w-16 h-16 rounded-full overflow-hidden border-3 border-gradient-to-r from-primary to-secondary p-0.5">
                  <Image
                    src={highlight.coverImage}
                    alt={highlight.title}
                    className="w-full h-full rounded-full object-cover"
                  />
                </div>
              ) : (
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary-100 to-secondary-100 border-3 border-gradient-to-r from-primary to-secondary flex items-center justify-center">
                  <Icon 
                    name={getHighlightIcon(highlight.type)} 
                    size={24} 
                    className="text-primary"
                  />
                </div>
              )}
              
              {highlight.isNew && (
                <div className="absolute -top-1 -right-1 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="Plus" size={12} color="white" />
                </div>
              )}
            </div>
            
            <p className="text-xs text-accent-600 mt-2 text-center max-w-16 truncate group-hover:text-accent-800 transition-colors">
              {highlight.title}
            </p>
          </button>
        ))}
        
        {/* Add New Highlight */}
        <button className="flex-shrink-0 group">
          <div className="w-16 h-16 rounded-full border-2 border-dashed border-accent-300 flex items-center justify-center group-hover:border-primary group-hover:bg-primary-50 transition-all duration-200">
            <Icon name="Plus" size={24} className="text-accent-400 group-hover:text-primary" />
          </div>
          <p className="text-xs text-accent-500 mt-2 text-center">Add New</p>
        </button>
      </div>
    </div>
  );
};

export default StoryHighlights;